import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GreenNotify } from "../../helper/helper";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import Loader from "../loader/loader";
import { Button, Col, Input, Row, Typography } from "antd";

const EditEmployerCard = () => {
  const location = useLocation();
  const [name, setName] = useState(location?.state?.item?.name);
  const [isloading, setIsLoading] = useState(false);
  const id = location?.state?.item?._id;
  console.log(location?.state?.item?._id);
  const navigate = useNavigate();

  const UpdateEmployer = () => {
    let getRes = (res) => {
      console.log("res of updateEmployerCard", res);
      GreenNotify("Employer card is updated successfully");
      navigate("/employerCard");
    };

    let body = {
      name: name,
    };

    callApi(
      "PATCH",
      `${routes.updateEmployerCard}/${id}`,
      body,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };

  return (
    <>
      <div style={{ marginBottom: "2rem", padding: "3rem" }}>
        <Loader loading={isloading} />
        <h2>Edit Card</h2>
        <Row gutter={216}>
          <Col span={8}>
            <Typography.Title level={5} style={{ marginTop: "2rem" }}>
              Name
            </Typography.Title>
            <Input
              style={{ marginTop: "1rem", height: "5rem" }}
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Name"
            />
          </Col>
        </Row>
        <Button
          type="primary"
          style={{ marginTop: "2rem" }}
          onClick={UpdateEmployer}
        >
          Edit
        </Button>
      </div>
    </>
  );
};

export default EditEmployerCard;
